import React from 'react';

import { cssMap } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled';
import Tooltip from '@atlaskit/tooltip';

interface WorkspaceNameMetadataProps {
	workspaceName: string;
}

export const WORKSPACE_NAME_MAX_LENGTH = 50;

const containerStyles = cssMap({
	root: {
		display: 'inline-block',
		maxWidth: '325px', // 50 chars at 13px average + ellipsis
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		whiteSpace: 'nowrap',
		verticalAlign: 'bottom',
	},
});

/**
 * Renders a workspace/team name in the search result metadata line.
 * Names longer than 50 characters are visually truncated with an ellipsis,
 * and the full name is revealed in a tooltip on hover.
 */
export const WorkspaceNameMetadata = ({
	workspaceName,
}: WorkspaceNameMetadataProps): React.JSX.Element => {
	const isTruncated = workspaceName.length > WORKSPACE_NAME_MAX_LENGTH;
	const displayName = isTruncated
		? `${workspaceName.slice(0, WORKSPACE_NAME_MAX_LENGTH)}...`
		: workspaceName;

	return (
		<Tooltip content={isTruncated ? workspaceName : null}>
			{(tooltipProps) => (
				<Box xcss={containerStyles.root} testId="workspace-name-metadata" {...tooltipProps}>
					{displayName}
				</Box>
			)}
		</Tooltip>
	);
};
